import Destinations from '../components/templates';

export const DestinationsContainer = () => {
  return <Destinations />;
};
